<template>
    <section class="hero-section text-center position-relative">
        <!-- Hero Slider -->
        <div class="owl-carousel owl-theme header-carousel position-relative vh-100" v-if="heroSlider && heroSlider.items.length > 0">
             <div class="owl-carousel-item position-relative" v-for="item in heroSlider.items" :key="item.id">
                 <img class="img-fluid vh-100 object-fit-cover w-100" :src="item.image.extra_large" alt="">
                 <div class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style="background: rgba(0,0,0,0.3);">
                    <div class="text-center text-white">
                        <h1 class="display-3 fw-bold font-serif mb-3">Seamless <span class="fst-italic fw-normal">furniture</span> <br> with natural fabrics</h1>
                        <a href="/products" class="btn btn-light rounded-pill px-4 py-2 mt-3">Shop Now</a>
                    </div>
                 </div>
             </div>
        </div>

        <!-- Fallback Static Info if no slider -->
        <div v-else class="hero-bg position-relative vh-100"
            style="background-color: #f2efeb; display: flex; align-items: center; justify-content: center; overflow: hidden;">
            <img src="https://placehold.co/1920x600/e0e0e0/8D6E63?text=Hero+Sofa+Image" id="hero-img"
                alt="Seamless furniture" class="position-absolute w-100 h-100 object-fit-cover"
                style="opacity: 0.8;">
            <div class="position-relative z-1">
                <h1 class="display-3 fw-bold font-serif mb-3">Seamless <span
                        class="fst-italic fw-normal">furniture</span> <br> with natural fabrics</h1>
                <a href="products.html" class="btn btn-dark rounded-pill px-4 py-2 mt-3">Shop Now</a>
            </div>
        </div>

        <!-- Parent Categories -->
        <div class="container position-absolute start-50 translate-middle-x" style="bottom: 50px; z-index: 2;">
            <div class="row g-4 justify-content-center">
                <div v-for="category in parentCategories" :key="category.id" class="col-6 col-md-3">
                    <div class="bg-white rounded-4 p-3 d-flex align-items-center gap-3 shadow-sm h-100">
                        <div class="flex-shrink-0">
                            <img :src="category.image ? category.image.small : 'https://placehold.co/100x100/transparent/8D6E63?text=' + category.name" :alt="category.name" class="rounded-circle object-fit-cover" style="width: 60px; height: 60px;">
                        </div>
                        <div class="text-start">
                            <h6 class="fw-bold mb-1 brand-font">{{ category.name }}</h6>
                            <span class="text-muted small">{{ category.products_count }} Products</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "HeroSection",
    props: {
        parentCategories: {
            type: Array,
            default: () => []
        },
        heroSlider: {
            type: Object,
            default: null
        }
    },
    watch: {
        heroSlider(newVal) {
            if (newVal && newVal.items.length > 0) {
                 this.$nextTick(() => {
                     this.initCarousel();
                 });
            }
        }
    },
    methods: {
        initCarousel() {
            $(".header-carousel").owlCarousel({
                autoplay: true,
                smartSpeed: 1500,
                items: 1,
                dots: true,
                loop: true,
                nav : true,
                navText : [
                    '<i class="bi bi-chevron-left"></i>',
                    '<i class="bi bi-chevron-right"></i>'
                ]
            });
        }
    }
}
</script>

<style scoped>
.brand-font {
    font-family: 'Playfair Display', serif;
}
</style>
